<!--
 * @Description: 发送记录
 * @Author: fely
 * @Date: 2020-06-11 11:54:20
 * @LastEditTime: 2020-12-15 18:14:17
 * @LastEditors: fely
--> 
<template>
  <div class="send-record-page">
    <div class="select-month">
      <div class="select-box">
        <div class="current-box" @click="selectMonth">{{currentMon}} <img src="~@/assets/images/dropDown.png" alt=""></div>
        <div class="drop-list" v-show="selectMon"> 
          <ul>   
            <li v-for="(item,index) in monthList"        
                :key="index"       
                @click="getSlip(item.id,index)">
                {{item.title}}
            </li> 
          </ul> 
          <div class="poper-arrow"></div>
        </div>
      </div>
      <div class="right-select">
        <div class="input-box"> <el-select v-model="username" filterable placeholder="请输入名字" @change="selectUser">   
          <el-option     
            v-for="item in nameList"     
            :key="item.name"     
            :label="item.name"     
            :value="item.name">   
          </el-option> 
        </el-select>
        </div>
        <div class="export-box">
          <el-dropdown @command="handleExport">
            <span class="el-dropdown-link">
              导出<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="原始表格">原始表格</el-dropdown-item>
              <el-dropdown-item command="员工签名">员工签名</el-dropdown-item>
              <el-dropdown-item command="发送失败记录">发送失败记录</el-dropdown-item>
          </el-dropdown-menu>
          </el-dropdown> 
          <!-- <el-select v-model="exportExcleName" placeholder="导出" @change="handleExport">
            <el-option     
               v-for="item in options"     
               :key="item.value"     
               :value="item.value">   
            </el-option> 
          </el-select> -->
        </div>
        <div class="dele-box">
          <el-popconfirm  title="本次发送记录删除后，将不可恢复，相关工资条也将一并删除，是否继续?"  @onConfirm="dele" :hideIcon='true' :style="{width:'200px'}">         
            <p slot="reference">删除</p>       
          </el-popconfirm>   
        </div>
      </div>
      
    </div>
    <div class="tab-bar">
      <el-radio-group v-model="tabbar" @change="handleTabChange">
        <el-radio-button :label="0">全部({{statusObj.all}})</el-radio-button>
        <el-radio-button :label="1">已读({{statusObj.isRead}})</el-radio-button>
        <el-radio-button :label="2">未读({{statusObj.unRead}})</el-radio-button>
        <el-radio-button :label="3" v-if="openSign">已签收({{statusObj.isSign}})</el-radio-button>
        <el-radio-button :label="4">发送失败({{statusObj.fail}})</el-radio-button>
        <el-radio-button :label="7" v-if="openFeed">有反馈({{statusObj.fknum}})</el-radio-button>
        <el-radio-button :label="5">已撤回({{statusObj.withdraw}})</el-radio-button>
        <el-radio-button :label="6" v-if="openSign">未签收({{statusObj.unSign}})</el-radio-button>
      </el-radio-group>
    </div>
    <div class="table-wrapper">
      <el-table :data="tableData" v-loading="loading" stripe>
        <el-table-column type="index" label="序号" header-align="left" align="left"></el-table-column>
        <el-table-column prop="name" label="姓名" header-align="left" align="left" >
        </el-table-column>
        <el-table-column prop="phone" label="手机号" header-align="left" align="left" min-width="100" >
        </el-table-column>
        <el-table-column prop="sendtime" label="发送时间" header-align="left" align="left" min-width="150" >
        </el-table-column>
        <el-table-column prop="status" label="发送状态" header-align="left" align="left"> 
          <template slot-scope="scope">   
            {{ scope.row.status == 0? '待发送': (scope.row.status == 1 ? '发送失败' : (scope.row.status ==2 ? '发送成功' : '撤回'))}} 
          </template>
        </el-table-column>
        <el-table-column prop="isread" label="已读" header-align="left" align="left"> 
          <!-- {{isread==0?'未读':'已读'}} --> 
          <template slot-scope="scope">   {{ scope.row.isread == 0? '否': '是'}} </template>
        </el-table-column> 
        <el-table-column prop="signurl" label="员工签名" header-align="left" align="left" v-if="openSign" width="180">
          <template slot-scope="scope">
            <el-image v-show="scope.row.issign==1" fit="contain" :src="scope.row.signurl" :preview-src-list="[scope.row.signurl]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="feedback" label="反馈" header-align="left" align="left" v-if="openFeed">
          <template slot-scope="scope">   
            <img :style="{height: '25px'}" src="~@/assets/images/feedback.png" @click="feedback(scope.row.payperid)" v-show="scope.row.feedbackid">
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" header-align="left" align="left"> 
          <template slot-scope="scope">
            <div class="operation">     
              <div @click="viewItem(scope.row.payperid)">查看</div>
              <div @click="scope.row.status==2 ? null:updateItem(scope.row.payperid)" :class="scope.row.status==2 ? 'unClick':''">修改</div>     
              <div class="back-btn" :class="scope.row.status!=2 ? 'unClick':''">       
                <el-popconfirm  title="您确定要撤回吗？" @onConfirm="withDraw(scope.row.payperid)" :hideIcon='true' v-model="scope.row.popConfirm">
                  <p slot="reference">撤回</p>
                </el-popconfirm>
              </div>
              <div :class="scope.row.status == 0 || scope.row.status == 2 ? 'unClick':''">
                <el-popconfirm  title="您确定要重新发送吗？"  @onConfirm="reSend(scope.row.payperid)" :hideIcon='true' v-model="scope.row.reSend">         
                  <p slot="reference">重发</p>       
                </el-popconfirm>
              </div>
            </div>
          </template>
         
        </el-table-column>
      </el-table>
    </div>
    <div class="pages-bar">
      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="page"
        :limit.sync="limit"
        @pagination="getPagerList"
      ></pagination>
    </div>
    <div class="mask-layer" v-show="isMask">
        <view-slip 
          @closeMask="closeMask" 
          v-show="currentMask==1" 
          :slipObj="slipObj" 
          :hiddenItem="hidenItem"
          :isshowzore="isshowzore"
          :isshownull="isshownull" ></view-slip>
        <update-slip 
          @closeMask="closeMask" 
          v-show="currentMask==2" 
          :slipObj="slipObj" 
          :payperid="perId"
          :paycomid="paycomId"
          :hiddenItem="hidenItem"
          :isshowzore="isshowzore"
          :isshownull="isshownull"></update-slip>
        <feedback-info @closeMask="closeMask" v-show="currentMask==3"  :feedlist="feedlist"></feedback-info>
    </div>
  </div>
</template>

<script>
import { getTitleList,getSendRecord,getUserName,getSendStatus,getPersonSlip,withdrawSlip,resendSlip,getFeedBack,deleSlip } from 'api/slip'
import { exportMethod } from 'api/downLoad'
import ViewSlip from './component/ViewSlip'
import UpdateSlip from './component/UpdateSlip'

import Pagination from 'common/pagination/index'

import FeedbackInfo from './component/FeedbackInfo'
export default {
  name: '',
  components: {
    ViewSlip,
    UpdateSlip,
    FeedbackInfo,
    Pagination
  },
  data() {
    return {
      currentIndex: 0,
      currentMon: '',     //当前  选择月份的标题
      username: '',       //选择的用户名
      nameList: [],       //用户列表
      popConfirm:false,   //
      visible: true,
      currentMask : 0,
      isMask:false,
      feedlist: [],
      selectMon: false,
      monthList: [],
      state: '',
      tabbar: 0,
      tableData: [],
      statusObj: {
        all: 0,       //全部
        isRead: 0,    //已读
        unRead: 0,    //未读
        isSign: 0,    //已签收
        fail: 0,      //发送失败
        withdraw: 0,  //撤回
        unSign: 0,    //未签收
        fknum: 0,     //反馈
      },
      paycomId: '',     // 公司工资条id
      perId: '', 
      loading: true,
      slipObj:'',   // 查看工资条对象
      // pager相关数据
      total: 0,           //数据总条数
      page: 1,
      limit: 10,
      // 发送相关配置
      openSign: 1,
      openFeed: 1,
      // 隐藏项
      hidenItem: '',
      // 是否显示 0
      isshowzore: 0,
      // 是否显示 空值
      isshownull: 0
    }
  },
  created() {
    this.getTitleList()
  },
  methods: {
    // 翻页
    getPagerList(){
      this.getSlip(this.paycomId,this.currentIndex)
    },
    // 获取薪资月份
    getTitleList(){
      let that = this
      that.currentMon = ''
      getTitleList(sessionStorage.getItem('companyId')).then(res => {
        if(res.code == 200){ 
          let arrTemp = res.data
          let arr = []
          let temp = 0
          for (let index = 0; index < arrTemp.length; index++) {
            if(index == 0){
              that.paycomId = arrTemp[0].paycomid
            }
            let element = {};
            
            if(index>0 && arrTemp[index].month == arrTemp[index-1].month && arrTemp[index].type == arrTemp[index-1].type){
              temp += 1
              element.title = arrTemp[index].year + '年' + arrTemp[index].month + '月份' + arrTemp[index].type + '('+ temp+')'
            }else{
              temp = 0
              element.title = arrTemp[index].year + '年' + arrTemp[index].month + '月份' + arrTemp[index].type
            }
            element.id = arrTemp[index].paycomid
            if(index==0 && !that.$route.query.payid )
            {
              that.currentMon = element.title
            }else if(that.$route.query.payid){
              if(element.id == that.$route.query.payid){
                that.currentMon = element.title
              }
            }
            arr.push(element)
          }
          that.monthList = arr
        }
      }).then(function(){
        if(!that.$route.query.payid){
          that.getUserName(that.paycomId)
          that.getSlip(that.paycomId,0)
        }else{
          that.getUserName(that.$route.query.payid)
          that.getSlip(that.$route.query.payid,-1)
        }
      })
      
    },
    // 获取员工姓名
    getUserName(paycomId){
      getUserName(paycomId).then( res => {
        if(res.code == 200){  
          this.nameList = res.data
        }
      })
    },
    // 选择月份 获取工资条信息
    getSlip(paycomId,index){
      if(!paycomId){
        this.loading = false
        return
      }
      this.loading = true
      this.paycomId = paycomId
      this.getUserName(paycomId)
      this.getSendStatus()
      // params
      let params = {}
      params.paycomid = this.paycomId
      params.showCount = this.limit
      params.currentPage = this.page
      getSendRecord(params).then( res => {
        if(res.code == 200){ 
          this.currentIndex = index
          this.total = res.data.listcount
          this.openSign = res.data.issign
          this.openFeed = res.data.isfeed
          if(index>=0)  this.currentMon = this.monthList[index].title
          // 隐藏项
          if(res.data.gztPayCom.hideitem){
            this.hidenItem = res.data.gztPayCom.hideitem
          }
          // 是否显示 0 、空值
          this.isshowzore = res.data.gztPayCom.isshowzore
          this.isshownull = res.data.gztPayCom.isshownull
          let arr = [] 
          res.data.record.forEach(element => {  
            if(element){
              element.popConfirm = false     
              element.reSend = false     
              arr.push(element) 
            }
          }); 
          // this.$set(this.tableData,arr)
          this.tableData = arr
          this.loading = false
        }else{ this.loading = false
        }
      }).catch( err => {
        this.loading = false
        console.log(err)
      })

    },
    // 获取状态
    getSendStatus(){
      getSendStatus(this.paycomId).then( res => {
        if(res.code == 200){ let statusObj = res.data[0] 
          this.statusObj.all = statusObj.zongnum 
          this.statusObj.isRead = statusObj.isread0num 
          this.statusObj.unRead = statusObj.zongnum - statusObj.isread0num 
          this.statusObj.isSign = statusObj.issign0num 
          this.statusObj.fail = statusObj.status1num 
          this.statusObj.withdraw = statusObj.status3num 
          this.statusObj.unSign = statusObj.zongnum - statusObj.issign0num
          this.statusObj.fknum = statusObj.fknum
        }
      })
    },
    // 选择薪资月份
    selectMonth(){
      this.selectMon = !this.selectMon
    },
    // 选择某个员工
    selectUser(value){
      let params = {}
      params.paycomid = this.paycomId
      params.name = value
      getSendRecord(params).then( res => {
        if(res.code == 200){ this.tableData = res.data.record
        }
      })
    },
    // 选择某个tab选项
    handleTabChange(tab){
      // tab
      this.loading = true
      let params = {}
      params.paycomid = this.paycomId
      params.showCount = this.limit
      params.currentPage = 1
      switch (tab) {
        case 0:  break;
        case 1: params.isread = 1; break;
        case 2: params.isread = 0; break;
        case 3: params.issign = 1; break;
        case 4: params.status = 1; break;
        case 5: params.status = 3; break;
        case 6: params.issign = 0; break;
        case 7: params.isfeed = 1; break;
        default: break;
      }
      getSendRecord(params).then( res => {
        if(res.code == 200){ 
          this.total = res.data.listcount
          this.tableData = [] 
          res.data.record.forEach(element => {
                element.popConfirm = false     
                element.reSend = false     
                this.tableData.push(element) }); 
          this.loading = false
        }else{ 
            this.loading = false
        }
      }).catch( err => {
        this.loading = false
        console.log(err)
      })
      
    },
    // 查看工资条
    viewItem(perId){
      getPersonSlip(this.paycomId,perId).then( res => {
        this.slipObj = res.data
        this.isMask = true
        this.currentMask = 1
      })
    },
    // 修改工资条
    updateItem(perId){
      getPersonSlip(this.paycomId,perId).then( res => {
        this.perId = perId
        this.slipObj = res.data
        this.isMask = true
        this.currentMask = 2
        this.stopMove()

      })
    },

    stopMove(){
      let m = function(e){e.preventDefault();};
      document.body.style.overflow='hidden';
      document.addEventListener("touchmove",m,{ passive:false });//禁止页面滑动
    },
    //开启页面滚动
    move(){
      let m =function(e){e.preventDefault();};
      document.body.style.overflow='';//出现滚动条
      document.removeEventListener("touchmove",m,{ passive:true });
    },
    // 撤回
    withDraw(perId){
      // this.popConfirm = !this.popConfirm
      withdrawSlip(this.paycomId,perId).then( res => {
        if(res.code == 200){
          this.getPagerList()
          this.$message.success('撤回成功！')
        }
      })
    },
    // 重发
    reSend(perId){
      resendSlip(sessionStorage.getItem('companyId'),sessionStorage.getItem('phone'),this.paycomId,perId).then( res => {
        if(res.code == 200){
          this.getPagerList()
          this.$message.success('重新发送成功！')
        }
      })
    },
    // 查看反馈信息
    feedback(perId){
      this.isMask = true
      this.currentMask = 3
      this.perId = perId
      getFeedBack(perId).then( res => {
        this.feedlist = res.data
      })
    },
    // 遮罩层消失
    closeMask(param){
      this.move()
      this.isMask = false
      if(param == 1){
        this.getPagerList()
      }else if(param == '手机号重复'){
        window.location.reload()
      }
      
    },
    // 导出
    handleExport(value){
      switch (value) {
        case '原始表格': 
          this.exportExcle() 
          break;
        case '员工签名':
          this.exportSign()
          break;
        case '发送失败记录': 
          this.exportFailRec()
          break;
        default: break;
      }
    },
    // 导出发送失败的记录
    exportFailRec(){
     exportMethod('/api/gztExcel/exportExcel3',{paycomid:this.paycomId},this.currentMon+'发送失败记录')
    },
    // 导出原始excle
    exportExcle(){
      exportMethod('/api/gztExcel/exportExcel1',{paycomid:this.paycomId},this.currentMon+'原始表格')
    },
    // 导出员工签名
    exportSign(){
      exportMethod('/api/gztExcel/exportExcel2',{paycomid:this.paycomId},this.currentMon+'员工签名')
    },
    // 删除工资条
    dele(){
      deleSlip(this.paycomId,sessionStorage.getItem('companyId')).then(res => {
        if(res.code == 200){
          this.tableData = []
          this.$message.success('删除成功')
          this.getTitleList()
        }else{
          this.$message.success('删除失败')
        }
      })
    }
  },
  mounted() {
    document.addEventListener('click', (e) => {
      let thisClassName = e.target.className
      if(thisClassName != 'current-box'){
        this.selectMon = false
      }
    })
  }
}
</script>

<style scoped lang="less">
.send-record-page{
  margin:0 auto;
  padding: 0 67px;
  // width: 990px;
  height: 100%;
  box-sizing: border-box;
  .select-month{
    box-sizing: border-box;
    padding-left: 30px;
    padding-right: 14px;
    height: 50px;
    border-bottom: 1px solid #F2F2F2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .select-box{
      position: relative;
      .current-box{
        font-size: 14px;
        display: flex;
        align-items: center;
        cursor: pointer;
        img{ margin-left: 10px; width: 8px; height: 5px;
        }
      }
      .drop-list{
        height: 250px;
        overflow-y: scroll;
        position: absolute;
        top: 30px;
        left: -20px;
        z-index: 9999;
        font-size: 14px;
        background-color: #fff;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        li{ width: 150px; text-align: left; line-height: 35px; padding-left: 20px;
        }
        li:hover{ background-color: #F5F7FA; cursor: pointer;
        }
      }
      .drop-list::-webkit-scrollbar{ width: 6px;
      }
      .drop-list::-webkit-scrollbar-thumb { background: rgba(144,147,153,.3); border-radius: 10px;
      }
      .drop-list::-webkit-scrollbar-track-piece { background: transparent;
      }
      .poper-arrow{
        position: absolute;
        top: -6px;
        left: 75px;
        -webkit-filter: drop-shadow(0 2px 12px rgba(0, 0, 0, .03));
        filter: drop-shadow(0 2px 12px rgba(0, 0, 0, .03));
      }
      .poper-arrow::after{ position: absolute; display: block; width: 0; height: 0; border-color: transparent; border-style: solid; content: " "; border-width: 6px; top: 1px; margin-left: -6px; border-top-width: 0; border-bottom-color: #FFF;
        }
    }
    .right-select{
      display: flex;
      .export-box{
        width: 72px;
        margin-left: 8px;
      }
      .dele-box{
        margin-left: 8px;
        font-size: 12px;
        width: 70px;
        height: 30px;
        color: #fff;
        border: 1px solid #e2e2e2;
        background: #fff;
        color: #606266;
        opacity: 1;
        border-radius: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .dele-box:hover{
        width: 72px;
        height: 32px;
        border: 0;
        background: #4962FE;
        color: #fff;
      }
      /deep/ .el-input__inner{
        height: 32px;
        line-height: 32px;
        border-radius: 2px;
        border: 1px solid #e2e2e2;
        padding-right: 4px;
        font-size: 12px;
      }
      /deep/ .el-input__icon{
        line-height: 32px;
      }
      /deep/ .el-popover__reference{
        text-align: center;
        
      }
      
    }
  }
  .tab-bar{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 76px;
    padding-left: 13px;
    box-sizing: border-box;
    font-size: 12px;
    /deep/ .el-radio-button__inner{
      border: 1px solid #e2e2e2;
      padding: 8px 12px;
      font-size: 12px;
    }
    /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner{
      border: 1px solid #4962FE;
    }
  }
  .table-wrapper{
    /deep/ .el-table--striped .el-table__body tr.el-table__row--striped td{
      background: #ECF2FF;
    }
    /deep/ .el-table thead th{
      background: #ECF2FF;
    }
    /deep/ .el-table{
      font-size: 12px;
    }
    .operation{
      margin-left: -16px;
      display: flex;
      div{
        margin-left: 16px;
        cursor: pointer;
      }
      .back-btn{
        position: relative;
        .popCon{ position: absolute; background-color: #fff;
        }
      }
    }
    .unClick{
      color: #E2E2E2;
      pointer-events: none;
    }
  }
  .pages-bar{
    margin-top: 20px;
  }
  .mask-layer{
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background:rgba(4,4,15,0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 20;
  }
}
.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
/deep/ .el-icon-circle-close:before{
  color: #ffffff;
}
.el-dropdown-link{
  border: 1px solid #e2e2e2;
  display: inline-block;
  width: 70px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
